import React, { useEffect, useRef, useState } from 'react';
import SideBarSkeleton from '../../Component/SideBarSkeleton';
import { apiHeader, BaseURL, imageUrl } from '../../config/apiUrl';
import classes from './ContractSent.module.css';
import TableSkeleton from '../../Component/TableSkeleton';
import NoData from '../../Component/NoData/NoData';
import { useSelector } from 'react-redux';
import { Get, Delete } from '../../Axios/AxiosFunctions';
import { useNavigate } from 'react-router-dom';
import PoperComponent from '../../Component/PopperComponent';
import AreYouSureModal from '../../modals/AreYouSureModal';
import { toast } from 'react-toastify';
import { LuEye, LuDownload } from 'react-icons/lu';
import SearchInput from '../../Component/SearchInput';
import useDebounce from '../../CustomHooks/useDebounce';
import ContractHeader from '../../Component/ContractHeader';
import ModalSkeleton from '../../modals/ModalSkeleton';
import { commaStyle } from '../../utils/functions';
import dayjs from '../../utils/timeUtils';
import { formatPhoneNumberWithoutPrefix, formatPhoneNumber } from '../../utils/functions';
import axios from 'axios';

const recordsLimit = 40;

const ContractSent = () => {
  const navigate = useNavigate();

  const accessToken = useSelector((state) => state?.authReducer?.access_token);
  const { logo } = useSelector(
    (state) => state?.companyReducer,
  );
  const baseApiUrl = BaseURL(`contract-agreement`);

  const [isFetchingTemplates, setIsFetchingTemplates] = useState(true);

  const [page] = useState(1);
  const [templateData, setTemplateData] = useState(null);
  const [openPopper, setOpenPopper] = useState(false);

  const anchorRef = useRef(null);

  const [selectedItem, setSelectedItem] = useState(null);
  const [openDeleteConfirmation, setOpenDeleteConfirmation] = useState('');
  const [search, setSearch] = useState('');
  const [isOpenEmailPreview, setIsOpenEmailPreview] = useState(false);
  const [companyLogoBase64, setCompanyLogoBase64] = useState(null);

  const debouncedSearchTerm = useDebounce(search, 500);

  const getAllContractSent = async () => {
    if (accessToken && accessToken?.length > 0) {
      const url = `${baseApiUrl}?status=all&search=${search}&page=${page}&limit=${recordsLimit}`;

      const response = await Get(url, accessToken);

      if (response?.status === 200) {
        setTemplateData(response?.data);
      }

      setIsFetchingTemplates(false);
    }
  };

  const formateDate = (date) => {
    return `${dayjs(new Date(date))?.format('MM-DD-YYYY')}`;
  };

  const getAgreementContent = (item, content) => {
    if (content) {
      let replacedContent = content || '';

      replacedContent = replacedContent?.replaceAll(
        '*|company_logo|*',
        `   
          <img style="
            width: 200px;
            height: 100%;
            object-fit: contain;
            object-position: center;
          " src="${companyLogoBase64 || ''}" alt="logo" />`,
      );

      replacedContent = replacedContent?.replaceAll(
        '*|company_name|*',
        item?.company_name || '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|company_address|*',
        item?.company_address || '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|entity_name|*',
        item?.entity?.name || '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|entity_city|*',
        item?.entity_city || '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|entity_country|*',
        item?.entity_country || '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|entity_state|*',
        item?.entity_state || '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|entity_street|*',
        item?.entity_street || '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|entity_zip|*',
        item?.entity_zip || '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|entity_phone|*',
        formatPhoneNumberWithoutPrefix(item?.entity_phone) || '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|listing_brokerage_name|*',
        item?.listing_brokerage_name || '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|listing_brokerage_address|*',
        item?.listing_brokerage_address || '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|Seller_Name|*',
        `${item?.seller?.firstName} ${item?.seller?.lastName}` || '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|seller_email|*',
        item?.seller_email || '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|seller_address|*',
        item?.seller_address || '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|seller_phone|*',
        formatPhoneNumber(item?.seller_phone) || '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|seller_title|*',
        item?.seller_title || '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|seller_signature_date|*',
        item?.seller_signature_date
          ? formateDate(item?.seller_signature_date)
          : '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|Buyer_Name|*',
        `${item?.buyer?.firstName} ${item?.buyer?.lastName}` || '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|buyer_email|*',
        item?.buyer_email || '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|buyer_address|*',
        item?.buyer_address || '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|buyer_phone|*',
        formatPhoneNumber(item?.buyer_phone) || '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|buyer_title|*',
        item?.buyer_title || '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|buyer_signature_date|*',
        item?.buyer_signature_date
          ? formateDate(item?.buyer_signature_date)
          : '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|broker_name|*',
        item?.broker?.name || '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|broker_firm_name|*',
        item?.broker_firm_name || '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|broker_provided_info|*',
        item?.broker_provided_info || '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|Business_Name|*',
        item?.business_name || '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|Business_Address|*',
        item?.business_address || '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|cooperating_brokerage_name|*',
        item?.cooperating_brokerage_name || '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|cooperating_brokerage_address|*',
        item?.cooperating_brokerage_address || '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|commission_percentage|*',
        item?.commission_percentage &&
          Number(item?.commission_percentage) >= 0
          ? `${Number(item?.commission_percentage)}%`
          : '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|commission_payment_terms|*',
        item?.commission_payment_terms || '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|cooperating_broker_name|*',
        item?.cooperating_broker_name?.name || '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|cooperating_broker_title|*',
        item?.cooperating_broker_title || '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|cooperating_broker_phone|*',
        formatPhoneNumberWithoutPrefix(item?.cooperating_broker_phone) || '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|cooperating_broker_email|*',
        item?.cooperating_broker_email || '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|Agreement_Title|*',
        item?.agreement_title || '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|Agreement_Date|*',
        item?.agreement_date ? formateDate(item?.agreement_date) : '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|closing_date|*',
        item?.closing_date ? formateDate(item?.closing_date) : '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|document_date|*',
        item?.document_date ? formateDate(item?.document_date) : '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|Termination_Reason|*',
        item?.termination_reason || '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|Clause_Reference|*',
        item?.clause_reference || '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|Due_Diligence_Deadline|*',
        item?.due_diligence_deadline || '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|Document_List|*',
        item?.document_list || '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|earnest_money_amount|*',
        item?.earnest_money_amount &&
          Number(item?.earnest_money_amount) >= 0
          ? `$${commaStyle(item?.earnest_money_amount)}`
          : '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|escrow_agent_name|*',
        item?.escrow_agent_name?.name || '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|escrow_company_name|*',
        item?.escrow_company_name || '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|purchase_price|*',
        item?.purchase_price && Number(item?.purchase_price) >= 0
          ? `$${commaStyle(item?.purchase_price)}`
          : '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|down_payment|*',
        item?.down_payment && Number(item?.down_payment) >= 0
          ? `$${commaStyle(item?.down_payment)}`
          : '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|loan_at_closing|*',
        item?.loan_at_closing && Number(item?.loan_at_closing) >= 0
          ? `$${commaStyle(item?.loan_at_closing)}`
          : '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|note_at_closing|*',
        item?.note_at_closing && Number(item?.note_at_closing)
          ? `$${commaStyle(item?.note_at_closing)}`
          : '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|start_date|*',
        item?.start_date ? formateDate(item?.start_date) : '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|end_date|*',
        item?.end_date ? formateDate(item?.end_date) : '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|sale_commission_amount|*',
        item?.sale_commission_amount &&
          Number(item?.sale_commission_amount) >= 0
          ? `$${commaStyle(item?.sale_commission_amount)}`
          : '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|sale_commission_percentage|*',
        item?.sale_commission_percentage &&
          Number(item?.sale_commission_percentage) >= 0
          ? `${Number(item?.sale_commission_percentage)}%`
          : '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|RE_commission_amount|*',
        item?.RE_commission_amount &&
          Number(item?.RE_commission_amount) >= 0
          ? `$${commaStyle(item?.RE_commission_amount)}`
          : '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|RE_commission_percentage|*',
        item?.RE_commission_percentage &&
          Number(item?.RE_commission_percentage) >= 0
          ? `${Number(item?.RE_commission_percentage)}%`
          : '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|equipment_price|*',
        item?.equipment_price && Number(item?.equipment_price) >= 0
          ? `$${commaStyle(item?.equipment_price)}`
          : '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|inventory_price|*',
        item?.inventory_price && Number(item?.inventory_price) >= 0
          ? `$${commaStyle(item?.inventory_price)}`
          : '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|term_cash|*',
        item?.term_cash || '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|term_sba|*',
        item?.term_sba || '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|term_conventional|*',
        item?.term_conventional || '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|term_other|*',
        item?.term_other || '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|seller_carry_years|*',
        item?.seller_carry_years || '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|seller_carry_rate|*',
        item?.seller_carry_rate || '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|acceptance_deadline|*',
        formateDate(item?.acceptance_deadline) || '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|inventory_margin|*',
        item?.inventory_margin || '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|buyer_execution_date_1|*',
        item?.buyer_execution_date_1
          ? formateDate(item?.buyer_execution_date_1)
          : '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|buyer_execution_date_2|*',
        item?.buyer_execution_date_2
          ? formateDate(item?.buyer_execution_date_2)
          : '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|seller_execution_date|*',
        item?.seller_execution_date
          ? formateDate(item?.seller_execution_date)
          : '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|date_executed|*',
        item?.date_executed ? formateDate(item?.date_executed) : '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|today_date|*',
        item?.today_date ? formateDate(item?.today_date) : '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|listing_broker_name|*',
        item?.listing_broker_name?.name || '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|listing_broker_title|*',
        item?.listing_broker_title || '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|listing_broker_email|*',
        item?.listing_broker_email || '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|listing_broker_phone|*',
        formatPhoneNumber(item?.listing_broker_phone) || '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|listing_broker_telephone|*',
        formatPhoneNumber(item?.listing_broker_telephone) || '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|listing_broker_signature_date|*',
        item?.listing_broker_signature_date
          ? formateDate(new Date())
          : '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|seller_entity_name|*',
        item?.seller_entity_name || '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|seller_entity_street|*',
        item?.seller_entity_street || '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|seller_entity_city|*',
        item?.seller_entity_city || '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|seller_entity_state|*',
        item?.seller_entity_state || '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|seller_entity_zip|*',
        item?.seller_entity_zip || '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|seller_entity_country|*',
        item?.seller_entity_country || '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|seller_entity_phone|*',
        formatPhoneNumberWithoutPrefix(item?.seller_entity_phone) || '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|buyer_entity_name|*',
        item?.buyer_entity_name || '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|buyer_signature|*',
        item?.buyer_signature
          ? `<img draggable="false" width="100" src="${item?.buyer_signature}" alt="Seller Signature" />`
          : '',
      );

      replacedContent = replacedContent?.replaceAll(
        '*|seller_signature|*',
        selectedItem?.seller_signature
          ? `<img draggable="false" width="100" src="${selectedItem?.seller_signature}" alt="Seller Signature" />`
          : '',
      );

      return replacedContent;
    } else {
      return '';
    }
  };

  const handleActionClick = (flag) => {
    if (flag == 'Delete') {
      setOpenDeleteConfirmation(true);
    } else if (flag == 'Edit') {
      navigate(`/contract-agreements/edit-agreement/${selectedItem?._id}`);
    }
  };

  const handleDelete = async () => {
    const response = await Delete(
      `${baseApiUrl}/${selectedItem?._id}`,
      apiHeader(accessToken),
    );

    if (response?.status === 200) {
      toast.success('Deleted successfully.');
      getAllContractSent();
      setSelectedItem(null);
      setOpenDeleteConfirmation(false);
    } else {
      toast.error(response.data || MSG_ERROR);
    }
  };

  const imageUrlToBase64 = async (url) => {
    const data = await fetch(url);
    const blob = await data.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => {
        const base64data = reader.result;
        resolve(base64data);
      };
      reader.onerror = reject;
    });
  };

  useEffect(() => {
    getAllContractSent();
  }, [accessToken, debouncedSearchTerm]);

  const handleLogo = async () => {
    const base64 = await imageUrlToBase64(imageUrl(logo));
    setCompanyLogoBase64(base64);
  };

  const generatePDF = async (item) => {
    try {
      const broker_name = `${item?.listing_broker_name?.firstName} ${item?.listing_broker_name?.lastName}`;
      const htmlContent = getAgreementContent(item, item?.content);
      const response = await axios.post(`${baseApiUrl}/download-contract`, 
        { name: item?.name, broker_name, htmlContent },
        { 
          responseType: 'blob',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`
          }
        }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${item?.name}.pdf`);
      
      document.body.appendChild(link);
      
      link.click();
      
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error generating PDF:', error);
    }
  }


  useEffect(() => {
    if (logo) {
      handleLogo();
    }
  }, [logo]);

  return (
    <>
      <style>
        {`
      .table100 {
        overflow-x:scroll !important;
        padding-top: 0px;
      }
      .table100-head {
        min-width: 940px;
        position: relative;
      }
      .table100.ver1 th {
        font-size: 13px;
      }
      .table100.ver1 td {
        font-size: 13px;
      }
      .table100-body {
        min-width: 940px;
        max-height: calc(100vh - 340px);
        margin-top: 3px;
        overflow: auto;
      }
      .table100-body td {
        padding-block: 18px;
      }
      .column1 {
        padding-left: 16px;
      }
      .table100.ver1 .table100-body tr {
        margin:15px;
      }
      .table100 .table100-head tr {
        margin: 0 15px;
      }
      .table100-foot {
        min-width: 940px;
        position: relative;
      }
      `}
      </style>
      <div>
        <SideBarSkeleton>
          <ContractHeader />
          <div className={[classes.mainContainer]}>
            <div className={[classes.headerContainer]}>
              <h3>Agreement Status</h3>
              <div className={[classes.inputDiv]}>
                <SearchInput
                  setter={setSearch}
                  value={search}
                  placeholder={'Search'}
                />

                {/* <Button
                  label="Add Agreement"
                  className={classes.addProjectBtn}
                  onClick={() => {
                    navigate('/contract-agreements/add-agreement');
                  }}
                /> */}
              </div>
            </div>

            <div className="table100 ver1 m-b-110">
              <div className="table100-head">
                <table>
                  <thead>
                    <tr className="row100 head">
                      <th
                        className="cell100 column1"
                        style={{ width: '5%', textAlign: 'start' }}
                      >
                        S.No
                      </th>
                      <th
                        className="cell100 column1"
                        style={{ width: '20%', textAlign: 'start' }}
                      >
                        Listing
                      </th>
                      <th
                        className="cell100 column2"
                        style={{ width: '20%', textAlign: 'start' }}
                      >
                        Party 1
                      </th>
                      <th
                        className="cell100 column3"
                        style={{ width: '20%', textAlign: 'start' }}
                      >
                        Party 2
                      </th>
                      <th
                        className="cell100 column3"
                        style={{ width: '20%', textAlign: 'start' }}
                      >
                        Party 3
                      </th>

                      <th
                        className="cell100 column3"
                        style={{ width: '10%', textAlign: 'start' }}
                      >
                        View
                      </th>

                      <th
                        className="cell100 column3"
                        style={{ width: '25%', textAlign: 'start' }}
                      >
                        Status
                      </th>
                    </tr>
                  </thead>
                </table>
              </div>
              {isFetchingTemplates ? (
                <TableSkeleton rowsCount={recordsLimit} colsCount={6} />
              ) : (
                <div className="table100-body js-pscroll ps ps--active-y">
                  <table>
                    <tbody>
                      {templateData?.result?.length > 0 ? (
                        templateData?.result?.map((item, index) => (
                          <tr
                            className="row100 body"
                            style={{
                              backgroundColor:
                                selectedItem?._id == item?._id && '#E5F5FF',
                            }}
                          >
                            <td
                              className="cell100 column1"
                              style={{
                                width: '5%',
                                textAlign: 'start',
                              }}
                            >
                              {page == 1
                                ? index + 1
                                : recordsLimit * (page - 1) + index + 1}
                            </td>
                            <td
                              className="cell100 column1"
                              style={{ width: '20%', textAlign: 'start' }}
                            >
                              {item?.listing?.companyName}
                            </td>
                            <td
                              className="cell100 column3"
                              style={{
                                width: '20%',
                                textAlign: 'start',
                                maxWidth: '35%',
                                textOverflow: 'ellipsis',
                                overflow: 'hidden',
                                textTransform: 'capitalize',
                              }}
                            >
                              {item?.recipients[0]
                                ? `${item?.recipients[0]?.name} (${item?.recipients[0]?.role})`
                                : '-'}
                            </td>

                            <td
                              className="cell100 column7"
                              style={{ width: '20%', textAlign: 'left' }}
                            >
                              <div
                                style={{
                                  position: 'relative',
                                  cursor: 'pointer',
                                }}
                              >
                                {item?.recipients[1]
                                  ? `${item?.recipients[1]?.name} (${item?.recipients[1]?.role})`
                                  : '-'}
                              </div>
                            </td>

                            <td
                              className="cell100 column7"
                              style={{ width: '20%', textAlign: 'left' }}
                            >
                              <div
                                style={{
                                  position: 'relative',
                                  cursor: 'pointer',
                                }}
                              >
                                {item?.recipients[2]
                                  ? `${item?.recipients[2]?.name} (${item?.recipients[2]?.role})`
                                  : '-'}
                              </div>
                            </td>
                            <td
                              className="cell100 column7"
                              style={{ width: '10%', textAlign: 'left', display: 'flex' }}
                            >
                              <div
                                style={{
                                  position: 'relative',
                                  cursor: 'pointer',
                                  width: 'fit-content',
                                }}
                                onClick={() => {
                                  setIsOpenEmailPreview(true);
                                  setSelectedItem(item);
                                }}
                              >
                                <LuEye size={25} />
                              </div>
                              {item?.status?.toLowerCase() == 'completed' && <div
                                style={{
                                  position: 'relative',
                                  cursor: 'pointer',
                                  width: 'fit-content',
                                  marginLeft: 5
                                }}
                                onClick={() => { generatePDF(item) }}
                              >
                                <LuDownload size={25} />
                              </div>}
                            </td>

                            <td
                              className="cell100 column7"
                              style={{ width: '25%' }}
                            >
                              <p
                                className={`${classes.status} ${
                                  classes[
                                    `color-${
                                      (item?.status?.toLowerCase() ==
                                        'error' &&
                                        'red') ||
                                      (item?.status?.toLowerCase() ==
                                        'sent' &&
                                        'green') ||
                                      (item?.status?.toLowerCase() ==
                                        'completed' &&
                                        'blue') ||
                                      (item?.status?.toLowerCase() ==
                                        'manually completed' &&
                                        'blue') ||
                                      (item?.status?.toLowerCase() ==
                                        'pending' &&
                                        'blue-1') ||
                                      item?.status?.toLowerCase() ==
                                        'created' ||
                                      (item?.status?.toLowerCase() ==
                                        'viewed' &&
                                        'black')
                                    }`
                                  ]
                                }`}
                              >
                                {item.status?.toLowerCase() ===
                                'pending'
                                  ? 'In-Progress'
                                  : item?.status}
                              </p>

                              <div
                                style={{
                                  position: 'relative',
                                  cursor: 'pointer',
                                }}
                              ></div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <NoData text={'No Contract Agreements Sent'} />
                      )}
                    </tbody>
                  </table>
                </div>
              )}
            </div>

            {/* {templateData?.result?.length > 1 && (
              <div className={[classes.paginationDiv]}>
                <PaginationComponent
                  totalPages={templateData?.totalPages}
                  currentPage={page}
                  setCurrentPage={setPage}
                />
              </div>
            )} */}

            <PoperComponent
              handleClick={handleActionClick}
              open={openPopper}
              setOpen={setOpenPopper}
              anchorRef={anchorRef}
              data={['Delete']}
            />
          </div>
        </SideBarSkeleton>
      </div>
      <ModalSkeleton
        show={isOpenEmailPreview}
        setShow={setIsOpenEmailPreview}
        borderRadius="20px"
        width="734px"
        borderLine={false}
        header={'Contract Preview'}
        showCloseIcon={true}
      >
        <div
          dangerouslySetInnerHTML={{ __html: getAgreementContent(selectedItem, selectedItem?.content) }}
          style={{
            maxHeight: '70dvh',
            overflowY: 'auto',
            overflowX: 'hidden',
          }}
        />
      </ModalSkeleton>
      <AreYouSureModal
        show={openDeleteConfirmation}
        setShow={setOpenDeleteConfirmation}
        subTitle={`Are you sure you want delete this template`}
        isApiCall={false}
        onClick={() => handleDelete()}
      />
    </>
  );
};

export default ContractSent;
